import $ from 'jquery';

export default function buttonETermin() {


        $(".sticky-element-termin-desktop .termin-link").mouseenter(function() {
            $(".termin-cta-text").css("display","inline-block");
            $(".termin-cta-text").css("width","fit-content");
            $(".sticky-element-termin-desktop .termin-button-text").css("width",271);
        });
        $(".sticky-element-termin-desktop .termin-link").mouseleave(function() {
            $(".termin-cta-text").css("display","none");
            $(".termin-cta-text").css("width",0);
            $(".sticky-element-termin-desktop .termin-button-text").css("width",0);
        });
        $(".sticky-element-termin-desktop .termin-cta-text").mouseenter(function() {
            $(".termin-cta-text").css("display","inline-block");
            $(".termin-cta-text").css("width","fit-content");
            $(".sticky-element-termin-desktop .termin-button-text").css("width",271);
        });
        $(".sticky-element-termin-desktop .termin-cta-text").mouseleave(function() {
            $(".termin-cta-text").css("display","none");
            $(".termin-cta-text").css("width",0);
            $(".sticky-element-termin-desktop .termin-button-text").css("width",0);
        });

}